/** Zip 操作エラーを i18n キー／表示文言へ */
export function getSampleZipApiError(error: unknown, t: (key: string, opts?: Record<string, unknown>) => string): string {
  const msg = error instanceof Error ? error.message : String(error || '');
  if (msg === 'sample.local_zip_required') {
    return t('sample.local_zip_required', {
      defaultValue: 'ローカル Zip モードです。Zip を開いてから操作してください',
    });
  }
  if (msg === 'sample.db_requires_login') {
    return t('sample.db_requires_login', {
      defaultValue: 'クラウド DB の利用にはログインが必要です',
    });
  }
  if (msg === 'zip_gate_timeout') {
    return t('sample.zip_gate_timeout', {
      defaultValue: '処理がタイムアウトしました。もう一度お試しください',
    });
  }
  if (msg === 'zip_pick_cancelled') {
    return t('sample.zip_pick_cancelled', { defaultValue: 'ファイル選択をキャンセルしました' });
  }
  if (msg === 'zip_pick_requires_gesture') {
    return t('sample.zip_pick_requires_gesture', {
      defaultValue: 'もう一度ボタンを押してファイルを選択してください',
    });
  }
  if (msg === 'sample.zip_missing_data') {
    return t('sample.zip_missing_data', {
      defaultValue: 'Zip に sample-manager/sample-data.json がありません',
    });
  }
  if (msg === 'sample.local_snapshot_not_loaded') {
    return t('sample.local_snapshot_not_loaded', {
      defaultValue: 'Zip セッションが未接続です',
    });
  }
  if (msg.startsWith('sample.') || msg.startsWith('usage_record.')) {
    return t(msg, { defaultValue: msg });
  }
  return t('sample.zip_error', { defaultValue: 'Zip 操作に失敗しました', detail: msg });
}
